import { Link, useLocation } from "wouter";
import { 
  LayoutDashboard, 
  Users, 
  Calendar, 
  DollarSign, 
  MoreHorizontal,
  Bell,
  UserCircle
} from "lucide-react";
import { useAuth } from "@/hooks/use-auth";

export function MobileNav() {
  const [location] = useLocation();
  const { user } = useAuth();
  
  const isActive = (path: string) => {
    return location === path || location.startsWith(path);
  };
  
  // Parent-specific navigation
  if (user?.role === "parent") {
    return (
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 z-10">
        <div className="flex items-center justify-around">
          <Link href="/parent">
            <div className={`flex flex-col items-center py-2 px-3 ${isActive('/parent') && !isActive('/parent/schedule') && !isActive('/parent/announcements') && !isActive('/parent/connect-child') && !isActive('/profile') ? 'text-primary' : 'text-gray-600'}`}>
              <LayoutDashboard className="h-5 w-5" />
              <span className="text-xs mt-1">Dashboard</span>
            </div>
          </Link>
          
          <Link href="/parent/schedule">
            <div className={`flex flex-col items-center py-2 px-3 ${isActive('/parent/schedule') ? 'text-primary' : 'text-gray-600'}`}>
              <Calendar className="h-5 w-5" />
              <span className="text-xs mt-1">Schedule</span>
            </div>
          </Link>
          
          <Link href="/parent/announcements">
            <div className={`flex flex-col items-center py-2 px-3 ${isActive('/parent/announcements') ? 'text-primary' : 'text-gray-600'}`}>
              <Bell className="h-5 w-5" />
              <span className="text-xs mt-1">Updates</span>
            </div>
          </Link>
          
          <Link href="/profile">
            <div className={`flex flex-col items-center py-2 px-3 ${isActive('/profile') ? 'text-primary' : 'text-gray-600'}`}>
              <UserCircle className="h-5 w-5" />
              <span className="text-xs mt-1">Profile</span>
            </div>
          </Link>
        </div>
      </nav>
    );
  }
  
  // Admin/Coach navigation (default)
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 z-10">
      <div className="flex items-center justify-around">
        <Link href="/dashboard">
          <div className={`flex flex-col items-center py-2 px-3 ${
            isActive('/dashboard') &&
            !isActive('/dashboard/team') &&
            !isActive('/dashboard/schedule') &&
            !isActive('/dashboard/payments') &&
            !isActive('/dashboard/fitness') &&
            !isActive('/dashboard/meal-plans') &&
            !isActive('/dashboard/announcements') &&
            !isActive('/dashboard/settings')
              ? 'text-primary'
              : 'text-gray-600'
          }`}>
            <LayoutDashboard className="h-5 w-5" />
            <span className="text-xs mt-1">Dashboard</span>
          </div>
        </Link>

        <Link href="/dashboard/team">
          <div className={`flex flex-col items-center py-2 px-3 ${isActive('/dashboard/team') ? 'text-primary' : 'text-gray-600'}`}>
            <Users className="h-5 w-5" />
            <span className="text-xs mt-1">Players</span>
          </div>
        </Link>

        <Link href="/dashboard/schedule">
          <div className={`flex flex-col items-center py-2 px-3 ${isActive('/dashboard/schedule') ? 'text-primary' : 'text-gray-600'}`}>
            <Calendar className="h-5 w-5" />
            <span className="text-xs mt-1">Schedule</span>
          </div>
        </Link>

        <Link href="/dashboard/payments">
          <div className={`flex flex-col items-center py-2 px-3 ${isActive('/dashboard/payments') ? 'text-primary' : 'text-gray-600'}`}>
            <DollarSign className="h-5 w-5" />
            <span className="text-xs mt-1">Payments</span>
          </div>
        </Link>

        {/* "More" sub-menu route does not exist as a dedicated page; link to
            settings as the closest existing destination so the tab is not a
            dead 404. Building a real /more drawer is out of scope here. */}
        <Link href="/dashboard/settings">
          <div className={`flex flex-col items-center py-2 px-3 ${
            isActive('/dashboard/fitness') ||
            isActive('/dashboard/meal-plans') ||
            isActive('/dashboard/announcements') ||
            isActive('/dashboard/settings') ||
            isActive('/profile')
              ? 'text-primary' : 'text-gray-600'
          }`}>
            <MoreHorizontal className="h-5 w-5" />
            <span className="text-xs mt-1">More</span>
          </div>
        </Link>
      </div>
    </nav>
  );
}
